import { render, staticRenderFns } from "./IntegrationCard.vue?vue&type=template&id=dba05670&scoped=true&"
import script from "./IntegrationCard.vue?vue&type=script&lang=js&"
export * from "./IntegrationCard.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationCard.vue?vue&type=style&index=0&id=dba05670&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba05670",
  null
  
)

export default component.exports